type ScrollBox = Pick<
  HTMLElement,
  | "clientHeight"
  | "clientWidth"
  | "offsetHeight"
  | "scrollHeight"
  | "scrollWidth"
>

/**
 * Return the distance the element can actually scroll vertically.
 *
 * A horizontal scrollbar is excluded from `clientHeight` but included in the
 * surrounding box. On a short, wide table that chrome can otherwise look like
 * vertical row overflow: infinite scroll never fills the first batch and row
 * menus are mounted inside a body too short to contain them.
 */
export const getVerticalScrollOverflow = (element: ScrollBox): number => {
  const reportedOverflow = Math.max(
    0,
    element.scrollHeight - element.clientHeight
  )
  const horizontalScrollbarHeight =
    element.scrollWidth > element.clientWidth
      ? Math.max(0, element.offsetHeight - element.clientHeight)
      : 0

  return Math.max(0, reportedOverflow - horizontalScrollbarHeight)
}
